import { render, staticRenderFns } from "./ImagesSlide.vue?vue&type=template&id=48f5fb47"
import script from "./ImagesSlide.vue?vue&type=script&lang=js"
export * from "./ImagesSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48f5fb47')) {
      api.createRecord('48f5fb47', component.options)
    } else {
      api.reload('48f5fb47', component.options)
    }
    module.hot.accept("./ImagesSlide.vue?vue&type=template&id=48f5fb47", function () {
      api.rerender('48f5fb47', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/slides/ImagesSlide.vue"
export default component.exports